export const EXCLUDED_LOCALES: string[] = process.env.GATSBY_EXCLUDED_LOCALES?.split(',') || [];

export const languages = [
  {
    isoCode: 'en',
    isoName: 'English',
    locale: 'en-us',
    name: 'English (United States)',
    nativeName: 'English (United States)',
  },
  {
    isoCode: 'fr',
    isoName: 'French',
    locale: 'fr-fr',
    name: 'French (France)',
    nativeName: 'Français (France)',
  },
  {
    isoCode: 'de',
    isoName: 'German',
    locale: 'de-de',
    name: 'German (Germany)',
    nativeName: 'Deutsch (Deutschland)',
  },
  {
    isoCode: 'it',
    isoName: 'Italian',
    locale: 'it-it',
    name: 'Italian (Italy)',
    nativeName: 'Italiano (Italia)',
  },
  {
    isoCode: 'ko',
    isoName: 'Korean',
    locale: 'ko-kr',
    name: 'Korean (South Korea)',
    nativeName: '한국어 (한국)',
  },
  {
    isoCode: 'pt',
    isoName: 'Portuguese',
    locale: 'pt-br',
    name: 'Portuguese (Brazil)',
    nativeName: 'Português (Brasil)',
  },
  {
    isoCode: 'es',
    isoName: 'Spanish',
    locale: 'es-es',
    name: 'Spanish (Spain)',
    nativeName: 'Español (España)',
  },
];

export const allSites = languages.map(({ locale, ...rest }) => ({
  ...rest,
  hreflang: locale,
  id: locale,
  includeInHfrelangTags: !EXCLUDED_LOCALES.includes(locale),
  locale,
  path: `/hc/${locale}`,
}));

export const sites = allSites.filter(({ locale }) => !EXCLUDED_LOCALES.includes(locale));

export const allLocales = allSites.map(({ locale }) => locale);

export const locales = allLocales.filter((locale) => !EXCLUDED_LOCALES.includes(locale));
